<template>
    <div v-if="imagesReady">
        <carousel :perPage="1" navigationPrevLabel="" navigationNextLabel="" :paginationEnabled="false" :navigationEnabled="true" :mouseDrag="false" :loop="true" :touchDrag="true" class="as-app-slider as-app-image-slider">
            <template v-for="(image, index) in images" >
                <slide v-if="image.__typename === 'StandardImage'" :key="'image-'+index" class="as-app-slider-item" :class="{'hide-on-print':(image.__typename === 'ThreeSixtyVRImage')}" :type="image.__typename">
                    <img :src="image.formats.jpg.size1280x960"/>
                </slide>
            </template>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: 'ImageSlider',
        components: {
            Carousel,
            Slide
        },
        props: {
            images: Array,
            guid: String,
        },
        data() {
            return {
                imagesReady: false,
                slickOptions: {

                }
            }
        },
        methods: {
            initSlider () {
                this.$nextTick(() => {
                    //console.log('NOW');
                })
            },
            moveArrayItem(arr, old_index, new_index) {
                while (old_index < 0) {
                    old_index += arr.length;
                }
                while (new_index < 0) {
                    new_index += arr.length;
                }
                if (new_index >= arr.length) {
                    var k = new_index - arr.length + 1;
                    while (k--) {
                        arr.push(undefined);
                    }
                }
                arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
                return arr; // for testing purposes
            }
        },
        computed: {
            // sortByInputValues: {
            //     get() {
            //         return this.sortOptions.sortBy
            //     },
            //     set(val) {
            //         this.sortOptions.sortBy = val
            //     }
            // },
        },
        mounted (){
            //console.log('Images', this.images);
        },
        created () {
            let oldIndex = this.images.findIndex(function(element){
                return element.__typename === 'Car360Image'
            })
            this.moveArrayItem(this.images, oldIndex, 1)
            this.imagesReady = true
            this.initSlider()
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/style.scss";
    @import "../styles/partials/_image-slider";
</style>